import React from 'react';

// Función para calcular la edad (incluida)
const getAge = (p) => {
    if (!p) return '';
    const dateStr = p.birthDate || p.fecha_nacimiento || p.dob;
    if (!dateStr) return '';
    const today = new Date();
    const birthDate = new Date(dateStr);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age + ' años';
};

const FixedPage = ({ children, pageNumber, totalPages, headerData }) => {
  const PAGE_WIDTH = '215.9mm'; // Carta
  const PAGE_HEIGHT = '279.4mm';
  const FOOTER_HEIGHT = '20mm';

  // --- CONFIGURACIÓN DE ALTURAS (RESTAURADO A LA VERSIÓN QUE TE GUSTABA) ---
  const isFirstPage = pageNumber === 1;
  const HEADER_HEIGHT = isFirstPage ? '47mm' : '30mm'; 

  const styles = {
    pageContainer: {
      width: PAGE_WIDTH,
      height: PAGE_HEIGHT,
      backgroundColor: 'white',
      margin: '0 auto 20px auto',
      boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'visible', 
      zIndex: 1
    },
    headerZone: {
      height: HEADER_HEIGHT,
      position: 'absolute',
      top: '8mm', // Restaurado el margen original
      left: 0, width: '100%',
      // Padding original para que la caja del paciente no se vea extraña
      padding: isFirstPage ? '0 20mm' : '0 15mm', 
      boxSizing: 'border-box',
      zIndex: 10,
      display: 'flex', 
      flexDirection: 'column', 
      // RESTAURADO: flex-end asegura que la caja del paciente esté abajo
      justifyContent: isFirstPage ? 'flex-end' : 'center', 
      position: 'absolute' // Aseguramos contexto de posicionamiento
    },
    footerZone: {
      height: FOOTER_HEIGHT,
      borderTop: '2px solid #333',
      position: 'absolute',
      bottom: 0, left: 0, width: '100%',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontSize: '9px',
      color: '#444',
      textAlign: 'center',
      padding: '0 10mm',
      zIndex: 10,
      lineHeight: '1.3',
      backgroundColor: 'white'
    },
    contentZone: {
      marginTop: `calc(${HEADER_HEIGHT} + 8mm)`, 
      marginBottom: FOOTER_HEIGHT,
      height: `calc(${PAGE_HEIGHT} - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT} - 8mm)`,
      padding: '5px 20mm',
      overflow: 'visible', 
      position: 'relative'
    },
    safetyLine: {
      position: 'absolute',
      bottom: 0, left: 0, width: '100%',
      borderBottom: '1px dashed red',
      opacity: 0.5,
      pointerEvents: 'none',
      display: 'flex', justifyContent: 'flex-end'
    },
    safetyText: {
      color: 'red', fontSize: '8px', backgroundColor: 'white', padding: '0 5px'
    },
    patientBox: {
      border: '1px solid #000',
      padding: '5px 10px',
      fontSize: '11px',
      fontFamily: 'Arial, sans-serif',
      display: 'flex', justifyContent: 'space-between',
      backgroundColor: '#f9f9f9', marginTop: '5px',
      width: '100%',
      boxSizing: 'border-box'
    },
    continuationHeader: {
      borderBottom: '2px solid #ccc',
      paddingBottom: '5px',
      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
      fontFamily: 'Arial, sans-serif', color: '#555', width: '100%'
    }
  };

  return (
    <div className="print-page" style={styles.pageContainer}>
      <style>{`
        @media print {
          .print-page {
            overflow: hidden !important;
            box-shadow: none !important;
            margin: 0 !important;
            page-break-after: always;
          }
          .safety-guide { display: none !important; }
        }
      `}</style>

      {/* 1. HEADER DINÁMICO */}
      <div style={styles.headerZone}>
        {isFirstPage ? (
          <>
            {/* SOLUCIÓN BLINDADA: POSICIONAMIENTO ABSOLUTO 
               Al usar 'position: absolute', sacamos el logo del flujo Flexbox.
               Esto evita que 'justify-content: flex-end' o cualquier estilo del nuevo editor
               aplaste el logo. 
            */}
            {headerData?.logoUrl && (
              <div style={{ 
                  position: 'absolute', // Clave: flota sobre el contenido
                  top: 0, 
                  left: '20mm', // Respetamos el padding lateral del header
                  right: '20mm',
                  height: '40mm', // Altura fija reservada para el logo
                  display: 'flex',
                  alignItems: 'center', // Centrado vertical en su zona
                  justifyContent: 'center', // Centrado horizontal
                  zIndex: 1
              }}>
                <img 
                    src={headerData.logoUrl} 
                    alt="Logo" 
                    style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'contain' // Se ajusta sin deformarse
                    }} 
                />
              </div>
            )}

            {/* CAJA DEL PACIENTE (Se queda abajo gracias a flex-end del padre) */}
            {headerData?.patient && (
              <div style={styles.patientBox}>
                <span><strong>PACIENTE:</strong> {headerData.patient.name} {headerData.patient.lastName}</span>
                <span><strong>C.I.:</strong> {headerData.patient.cedula || headerData.patient.idNumber}</span>
                {/* EDAD AGREGADA */}
                <span><strong>EDAD:</strong> {getAge(headerData.patient)}</span>
                <span><strong>FECHA:</strong> {new Date().toLocaleDateString()}</span>
              </div>
            )}
          </>
        ) : (
          <div style={styles.continuationHeader}>
             <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '10px', fontWeight: 'bold', color: '#000' }}>
                    {headerData?.patient ? `${headerData.patient.name} ${headerData.patient.lastName}` : 'Paciente'}
                </span>
                <span style={{ fontSize: '9px' }}>
                    C.I.: {headerData?.patient?.cedula || headerData?.patient?.idNumber || 'S/C'}
                </span>
             </div>
             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <span style={{ fontSize: '9px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                    Informe Médico (Cont.)
                </span>
                <span style={{ fontSize: '9px' }}>
                    Fecha: {new Date().toLocaleDateString()}
                </span>
             </div>
          </div>
        )}
      </div>

      {/* 2. CONTENIDO */}
      <div style={styles.contentZone}>
        {children}
        <div className="safety-guide" style={styles.safetyLine}>
           <span style={styles.safetyText}>FINAL DE LA HOJA (Corte aquí)</span>
        </div>
      </div>

      {/* 3. FOOTER */}
      <div style={styles.footerZone}>
        {headerData?.footerText ? (
           <div dangerouslySetInnerHTML={{ __html: headerData.footerText }} />
        ) : (
           <span>Modifique su dirección en la configuración</span>
        )}
        <span style={{ marginTop: '2px', fontWeight: 'bold', fontSize: '8px' }}>
          Página {pageNumber} de {totalPages}
        </span>
      </div>
    </div>
  );
};

export default FixedPage;